import * as types from './types'
import http from '@/Plugins/api'

export default {
  setPager({ commit }, data) {
    commit(types.SET_PAGER, data)
  },
  setChecked({ commit }, data) {
    commit(types.SET_CHECKED, data)
  },
  resetBlob({ commit }, data) {
    commit(types.RESET_BLOB, data)
  },
  setBlobData({ commit }, data) {
    commit(types.SET_BLOB_DATA, data)
  },
  async getBlobs({ commit }, data) {
    commit(types.RESET_BLOBS)
    const r = await http.get(`v2/storage`, {
      params: data,
    })
    commit(types.SET_BLOBS, r.data.data)
    return r.data.data
  },
  async editBlob({ commit }, data) {
    commit(types.SET_BLOB, data)
  },
  async getBlob({ commit }, id) {
    const r = await http.get(`v2/storage/${id}`)
    commit(types.SET_BLOB, r.data.data)
    return r.data.data
  },
  async saveBlob({ commit }, data) {
    let r = null
    r = await http.post('v2/storage', data)
    return r.data.data
  },
  async removeBlob({ commit }, data) {
    const r = await http.post(`v2/storage/delete`, data)
    return r.data.data
  },
}
